module.exports = __webpack_public_path__ + "static/Screenshot_2018-07-29_18-31-22.fa5d9854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/sg-site/thumb/Screenshot_2018-07-29_18-31-22.png
// module id = 261
// module chunks = 35783957827783 246384609461072